const contact = {
  title: "Get in Touch",
  description:
    "We’re here to answer your questions! Reach out for product inquiries, partnership opportunities, or to schedule a demo.",
  locations: [
    {
      title: "Silicon Slopes, USA",
      address: "1543 W 1430 N STE 200, Orem, UT 84057",
      phone: "+1 385.625.9812",
      email: "info@surfacepix.com",
      hours: "Mon – Sat: 09:00 AM – 05:00 PM",
      note: "Showroom: By Appointment Only",
    },
    {
      title: "Manufacturer, Germany",
      address: "Werkstrasse 15, 57537 Wissen",
      phone: "+49 2742.966800",
      email: "info@wallpen.com",
    },
  ],
};

export default contact;
